import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { actionAddPostbackSettings } from './addPostbackSettings';

import {
  ACTION_LOAD_POSTBACK_SETTINGS__REQUEST,
  ACTION_LOAD_POSTBACK_SETTINGS__SUCCESS,
  ACTION_LOAD_POSTBACK_SETTINGS__FAIL,
} from '../actionTypes';


const actionLoadPostbackSettingsSuccess = () => ({
  type: ACTION_LOAD_POSTBACK_SETTINGS__SUCCESS,
});

const actionLoadPostbackSettingsFail = error => ({
  type: ACTION_LOAD_POSTBACK_SETTINGS__FAIL,
  payload: {
    error,
  },
});

export const actionLoadPostbackSettingsRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_POSTBACK_SETTINGS__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/postback',
      { }
    ).then(
      result => {
        dispatch(actionAddPostbackSettings(result.value));

        dispatch(actionLoadPostbackSettingsSuccess());
      },
      error => {
        dispatch(actionLoadPostbackSettingsFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
